import { Link } from 'react-router-dom';

const highlights = [
  { icon: 'ri-capsule-line', text: '多種劑型選擇' },
  { icon: 'ri-leaf-line', text: '天然選材原料' },
  { icon: 'ri-layout-grid-line', text: '多元包裝設計' },
  { icon: 'ri-customer-service-2-line', text: '專屬業務服務' },
];

export default function ServiceCtaSection() {
  return (
    <section className="relative py-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=top%20down%20aerial%20view%20of%20healthy%20natural%20ingredients%20herbs%20spices%20vegetables%20colorful%20arrangement%20on%20white%20background%2C%20health%20supplement%20raw%20materials%20flat%20lay%20photography&width=1920&height=600&seq=service-cta-bg-01&orientation=landscape"
          alt="代工服務 CTA 背景"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-[#2d5a2d]/85" />
      </div>

      <div className="relative z-10 max-w-screen-xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-10">
          <span className="inline-block bg-[#4CAF50]/25 border border-[#4CAF50]/50 text-green-300 text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-5">
            開始代工合作
          </span>
          <h2 className="text-white font-bold leading-tight mb-5">
            讓康永生技成為<br />您的專屬代工夥伴
          </h2>
          <p className="text-green-200 text-[1.0625rem] leading-[1.75] max-w-2xl mx-auto mb-10">
            不論您的產品計畫大小，康永都能提供專業且具彈性的代工解決方案。立即聯絡我們，讓您的產品快速上市。
          </p>
          <div className="flex flex-wrap justify-center gap-4 mb-12">
            <Link
              to="/contact/form"
              className="whitespace-nowrap bg-white text-[#2d5a2d] hover:bg-green-50 font-bold text-[1.0625rem] px-10 py-4 rounded-full transition-all duration-300 cursor-pointer"
            >
              立即諮詢代工服務
            </Link>
            <Link
              to="/partnership"
              className="whitespace-nowrap bg-transparent border-2 border-white text-white hover:bg-white/10 font-semibold text-[1.0625rem] px-10 py-4 rounded-full transition-all duration-300 cursor-pointer"
            >
              了解合作流程
            </Link>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
            {highlights.map((h) => (
              <div key={h.text} className="flex items-center justify-center gap-2 bg-white/10 rounded-xl py-4 px-3">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className={`${h.icon} text-green-300 text-xl`} />
                </div>
                <span className="text-white font-medium text-[0.9375rem] whitespace-nowrap">{h.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
